"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.draftScriptTtlMs = exports.scriptRuntimeMaxTtlMs = void 0;
const names_and_enums_1 = require("../names-and-enums");
/**
 * Max total duration of a kahbaRuntime instance.
 * Used for setting some cleanup / key expiration.
 */
function scriptRuntimeMaxTtlMs() {
    return names_and_enums_1.DayMs;
}
exports.scriptRuntimeMaxTtlMs = scriptRuntimeMaxTtlMs;
function draftScriptTtlMs() {
    return names_and_enums_1.DayMs;
}
exports.draftScriptTtlMs = draftScriptTtlMs;
//# sourceMappingURL=runtime-script.js.map